<template>
  <div class="app">
    <header-bar :user="user"></header-bar>
    <div class="loading" v-if="loading">
        <div class="sk-wave">
                <div class="sk-rect sk-rect1"></div>
                <div class="sk-rect sk-rect2"></div>
                <div class="sk-rect sk-rect3"></div>
                <div class="sk-rect sk-rect4"></div>
                <div class="sk-rect sk-rect5"></div>
        </div>
    </div>
    <div class="container">
      <transition name="fade" appear>
    	<router-view :user="user" :loading="loading"></router-view>
      </transition>
    </div>
  </div>
</template>
<script>
import HeaderBar from './components/HeaderBar'
import Auth from './data/Auth'
import * as firebase from "firebase";
import firebaseApp from  "./data/FirebaseApp";
import EventBus from './components/EventBus'

export default {
  data() {
    return {
      user: null,
      loading: true
    }
  },
  components: {
    HeaderBar
  },
  methods: {
    processUser (authed) {
      if (authed === null) {
        this.user = null
        return
      }

      var that = this

      firebase.database().ref('/users/' + authed.uid).once('value').then(function(snapshot) {

        that.user.username = snapshot.val().username;
      });

      this.user = {
        userTitle: authed.providerData[0].displayName || authed.providerData[0].email || '', // if there's no displayName, take the email, if there's no email, use an empty string
        imageUrl: authed.providerData[0].photoURL, // Firebase 3 no longer supports auto Gravatar image fetch
        uid: authed.uid
      }
    },
    stopLoading: function() {
      this.loading = false
    }
  },
  created() {
    EventBus.$on('loaded', this.stopLoading)
    Auth.onAuth(this.processUser) // processUser everytime auth state changes (signs in or out)
    this.processUser(Auth.getAuth()) // processUser in case user is already signed i

  },
  mounted() {
  }
}

</script>

<style lang="scss">
  @import './assets/app.scss'
</style>



// WEBPACK FOOTER //
// App.vue?5fd3841e